<template>
  <div
    v-if="message"
    :class="classes.join(' ')">
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">×</span>
    </button>
    <div v-html="message"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      message: '',
      type:    '',
      classes: [
        'alert',
        'alert-dismissible'
      ]
    }
  },
  methods: {
    showMessage (data) {
      this.type = data.type

      let htmlClass = 'alert-primary'

      switch (this.type) {
        case 'info':
          htmlClass = 'alert-primary'
          break
        case 'success':
          htmlClass = 'alert-success'
          break
        case 'error':
          htmlClass = 'alert-danger'
          break
      }

      this.classes.push(htmlClass)

      this.message = data.message
    }
  }
}
</script>
